import template from './report.html';

class ReportViewModel {
	constructor(page) {
		this.page = page;
		this.report_definition = ko.observable();
		this.schema_name = ko.observable('reports_data');
		this.table_name = ko.observable();

		this.title = ko.observable('Placeholder');
		this.description = ko.observable('Placeholder');
		this.query = { query_sql: ko.observable('') };
		this.report_status_message = ko.observable('');
		this.report_id = this.page.bindings.report_id;
		this.report_created_date = ko.observable();
		this.flag = ko.observable(false);

		this.report_definition_id = ko.observable();;
		this.version = ko.observable();
		this.email_list = ko.observableArray([]);
		this.table_data = ko.observableArray([]);
		this.report_data;

		//table Info
		this.record_total = ko.observable('');
		this.total_pages = ko.observable('');

		this.download_progress = ko.observable('0');
		this.download_progress_bar = ko.observable(false);
		this.export_csv_btn = ko.observable(true);

		this.is_error = ko.observable(false);
		ko.bindingHandlers.alert_status = {
			update: (element, valueAccessor) => {
				let value = ko.unwrap(valueAccessor());
				if (value != 'warning' && value != 'danger') {
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-danger', false);
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-info', true);
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-warning', false);
				}
				else if (value === 'warning') {
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-danger', false);
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-info', false);
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-warning', true);
				}
				else if (value === 'danger') {
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-danger', true);
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-info', false);
					ko.utils.toggleDomNodeCssClass(element, 'ps-alert-warning', false);
				}
			}
		};
	}

	async load() {
		// Fetch report definition based on the report definition id
		let query_obj = {
			schema: 'reports',
			table: 'v_reports',
			fields: ['name', 'description', 'report_definition_id', 'version'],
			filter: [
				{ field: 'report_id', operand: '=', value: this.page.bindings.report_id }
			],
			limit: 1
		};

		let response = await Grape.fetches.getJSON('/api/record', query_obj);
		if (response.status === 'OK') {
			let report = response.records[0];
			this.title(report.name);
			this.description(report.description);
			this.report_definition_id(report.report_definition_id);
			this.version(report.version);
			this.report_definition(report);
		}
		else
			throw new Error('Error!');
	}

	async navigation_url() {
		this.getResults(this.page.bindings.report_id);
	}

	async getResults(report_id) // Select or generate the report corresponding with the query or the function
	{
		let data = await Grape.fetches.getJSON('/api/report', { 'report_id': report_id });
		if (data) {
			if (data.metadata) {
				this.report_data = data.metadata;
				this.report_created_date(data.metadata.date_inserted);
			}

			if (data.status === 'ERROR' || ['Error', 'Completed', 'NewTask', 'Running', 'Starting', 'Pending'].indexOf(data.report_status) < 0) {
				this.is_error('warning');
				this.report_status_message('Error - no report data to display! Please ensure the query, table, or function has data!');
				return null;
			}

			if (data.report_status === 'Error') {
				this.is_error('danger');
				this.report_status_message(data.report_status);

				let response = await Grape.alerts.confirm({
					type: 'error',
					title: 'Error!',
					message: 'An unknown error occurred. Please ensure the query is valid or contact IT support. Do you want to open a log file?'
				});

				if (response)
					window.open('/api/bgworker/schedules/' + report_id + '/log', '_blank');
			}
			else if (data.report_status === 'Completed') {
				this.is_error(false);
				this.report_status_message('');
				this.table_name(data.result_table);

				let options = {
					schema: this.schema_name(),
					table: this.table_name()
				}

				let result = await Grape.fetches.getJSON('/api/record', options);
				if (result) {
					if (result.records.length > 0) {
						this.table_data(result.records);
						this.record_total(result.total);
						this.total_pages(result.total_pages);
					}
					else {
						Grape.alerts.alert({
							type: 'warning',
							title: 'No data!',
							message: 'There is no data to display for this report.'
						});
					}
				}
			}
			else {
				if (data.report_status === 'Running')
					this.report_status_message(data.report_status);
				else if (data.report_status === 'NewTask')
					this.report_status_message(data.report_status);
				else if (data.report_status === 'Pending')
					this.report_status_message(data.report_status);
				else if (data.report_status === 'Starting')
					this.report_status_message(data.report_status);

				// Try again in 2000 milliseconds
				this.timer = setTimeout(
					() => {
						this.getResults(report_id);
					},
					2000
				);
			}
		}
	}

	async send_to_email(v, e) {
		console.log('send_to_email');

		let bindings = {
			initial_values: {
				'description': this.description(),
				'record_total': this.record_total(),
				'report_id': this.report_id,
				'name': this.title()
			}
		};

		await Grape.dialog.open('UserEmailListSend', bindings);

	}

	async refreshReportResults() {
		let data = await Grape.fetches.postJSON('/api/report/create',
			{
				report_definition_id: this.report_definition_id(),
				version: this.version(),
				report_function_criteria: this.report_data.report_function_criteria
			}
		);
		if (data.status === 'OK') {
			if (!data.report) {
				Grape.alerts.alert({
					type: 'warning',
					message: 'User does not have the correct permission to run this report',
					title: 'Report Creation Error'
				});
			}
			else {
				let url = `/reports/report?report_id=${data.report.report_id}`;
				Grape.navigate(url);
			}
		}
	}

	async cancelProcessReports(data) {
		let decision = await Grape.alerts.confirm({
			type: 'warning',
			title: 'Delete Report',
			message: 'Delete the generated report and return to Report Definition page'
		});

		if (decision) {
			if (decision === true) {
				let reports = [
					{ 'report_id': this.report_id }
				];

				let url = ['/reports/definition', String(this.report_definition_id()), String(this.version)].join('/');
				let process_cancel_result = await Grape.fetches.postJSON('/api/reports/delete', { reports });

				if (process_cancel_result != -1) {
					this.report_status_message('Report creation was canceled');
					clearTimeout(this.timer);
					Grape.navigate(url);
				}
				else
					Grape.alerts.alert({ type: 'warning', title: 'Unknown error', message: 'We have encountered an unknown error. Please contact IT support to look into this matter. [3]' });
			}
			else
				return;
		}
	}

	backToTop() {
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	}

	backToReportDefinition() {
		Grape.navigate(`/reports/definition/${String(this.report_definition_id())}/${String(this.version())}`);
	}

	copyLink() {
		let url = window.location.href;
		let link = `<a href='${url}'>${url}</a>`;
		navigator.clipboard.writeText(url);
		Grape.alerts.alert({ type: 'info', title: 'Report Link Copied', message: link });
	}

	async downloadCSV() {

		this.download_progress('0');
		this.download_progress_bar(true);
		this.export_csv_btn(false);

		let fetches = window.Grape.fetches;
		let one_megabyte = 1048575;

		let formatted_date = new Date(this.report_created_date());
		let export_filename = this.title() + ' v' + this.report_id + '(' + formatted_date.getFullYear() + "-" + (formatted_date.getMonth() + 1) + "-" + formatted_date.getDate() + " " + formatted_date.getHours() + ":" + formatted_date.getMinutes() + ":" + formatted_date.getSeconds() + ').csv';

		// get file_size of report stored locally
		let result = await fetches.fetchJSON('/reports/' + this.report_id + '/file-size');
		let file_length = parseInt(result.file_size);

		let url = '/reports/' + this.report_id + '/export/csv/' + export_filename;

		let opt = {
			method: 'GET',
			headers: {
				'Accept': '*/*',
				'Connection': 'keep-alive'
			}
		};

		// initialize download_control with predefined settings
		let download_control = {
			retry_limit: 5,
			retry_count: 0,
			segment_count: 0,
			segment_length: (one_megabyte * 5), // 5MB chunks
			expected_segment_count: 1,
			time_out: 1000 * 60 * 2,
			only_test_factor: 0.5
		};

		// perform rough download speed test
		if (file_length > one_megabyte) {

			opt.headers.Range = `bytes=0-${one_megabyte}`; // set range header to first 1MB segment
			let start_time = Date.now();
			await fetches.fetchBlob(url, opt);
			let end_time = Date.now();

			// update expected_segment_count and time_out based on API result
			download_control.expected_segment_count = Math.ceil(file_length / download_control.segment_length);
			download_control.time_out = (end_time - start_time) * 5 * 10;

		} else {
			download_control.retry_limit = 2;
		}

		let controller, signal;
		let file_segments = [];

		let start_bytes = 0;
		let end_bytes;

		// loop through each 5MB segment
		while ((start_bytes < file_length) && (download_control.retry_count < download_control.retry_limit)) {

			end_bytes = start_bytes + download_control.segment_length;

			if (end_bytes > file_length)
				end_bytes = file_length;

			controller = new AbortController();
			signal = controller.signal;

			// set range header to current segment based on start_bytes and end_bytes
			opt.headers.Range = `bytes=${start_bytes}-${end_bytes}`;
			opt.signal = signal;

			// if time_out reached, abort
			let try_timer = setTimeout(() => {
				controller.abort('Download Timeout');
			}, download_control.time_out);

			try {

				// call ReportExportCSV (download) API with current segment range
				let response = await fetch(url, opt);

				if (response.ok) {

					clearTimeout(try_timer);
					let blob = await response.blob()
					file_segments.push(blob); // add response blob into file_segments array

					start_bytes += download_control.segment_length + 1; // update start_bytes for next segment
					download_control.retry_count = 0;
					download_control.segment_count++;

					// update progress bar value
					let percentage_download = Math.ceil((download_control.segment_count / download_control.expected_segment_count) * 100);
					this.download_progress(percentage_download);

				} else {

					console.log(`Response error response.status -> ${response.status}`);
					clearTimeout(try_timer);
					download_control.retry_count++;

				}
			}
			catch (e) {

				console.log(`Request error -> ${JSON.stringify(e)} retry_count -> ${download_control.retry_count} with signal -> ${signal.reason}`)
				clearTimeout(try_timer);
				download_control.retry_count++;

			};
		}

		// if actual segment_count not matching expected_segment_count, alert and return
		if (download_control.segment_count != download_control.expected_segment_count) {

			Grape.alerts.alert({
				type: 'error',
				title: 'Download Failed ',
				message: `Download of ${export_filename} failed after ${download_control.retry_limit} consecutive attempts.`,
			});

			this.download_progress('0');
			this.download_progress_bar(false);
			this.export_csv_btn(true);

			return;

		}

		// create new Blob based on all file_segments array and trigger download
		const blob = new Blob(file_segments, { type: 'text/csv' });
		const downloadUrl = URL.createObjectURL(blob);
		const a = document.createElement("a");
		a.href = downloadUrl;
		a.download = export_filename;
		a.target = '_blank';
		document.body.appendChild(a);
		a.click();

		// cleanup the DOM
		document.body.removeChild(a);
		window.URL.revokeObjectURL(downloadUrl);

		this.download_progress('100');

		Grape.alerts.alert({
			type: 'success',
			title: 'Download Complete ',
			message: `Download of ${export_filename} complete.`,
		});

		this.download_progress_bar(false);
		this.export_csv_btn(true);

	}

	btn_help_click() 
	{
		Grape.show_dialog('HelpDialog', '/reports/help/report_help.html', {});
	}
}

class ReportPage {
	constructor(bindings, element) {
		this.bindings = bindings;
		this.element = element;
		this.viewModel = new ReportViewModel(this);
		this.name = 'ReportPage';
	}

	async init() {
		this.viewModel.load();
	}

	updateData() {
		this.viewModel.navigation_url();
	}

	teardown() {
		clearTimeout(this.viewModel.timer);
	}
}

export default {
	route: '[/]reports/report?report_id=:report_id',
	page_class: ReportPage,
	template: template
};
